import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useCopyMarkdown } from './documentMarkdown';

/** Copies the given Markdown to the clipboard. Sits beside `ExpandAllSectionsButton`. */
export function CopyMarkdownButton({ markdown }: { markdown: string }) {
  const copy = useCopyMarkdown();
  return (
    <Tooltip title="Copy as Markdown">
      <IconButton size="small" onClick={() => void copy(markdown)} aria-label="Copy as Markdown">
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
